module.exports = __webpack_public_path__ + "img/bonus_symbol_4.914b7926.png";